/**
 * Fetches extra Shopify paginated collection pages and merges A–Z rows into one view
 * (default collection order spans parent brands across pages).
 */
(function () {
  function escLetterAttr(letter) {
    if (typeof CSS !== 'undefined' && CSS.escape) {
      return CSS.escape(letter);
    }
    return String(letter).replace(/["\\]/g, '\\$&');
  }

  function mergeRows(container, rows) {
    rows.forEach(function (row) {
      var letter = row.getAttribute('data-letter');
      if (!letter) return;
      var linksWrap = row.querySelector('.brands-a-z__links');
      var existing = container.querySelector(
        '.brands-a-z__letter-row[data-letter="' + escLetterAttr(letter) + '"]'
      );
      if (existing && linksWrap) {
        var dest = existing.querySelector('.brands-a-z__links');
        if (dest) {
          while (linksWrap.firstElementChild) {
            dest.appendChild(linksWrap.firstElementChild);
          }
        }
        row.remove();
      } else {
        container.appendChild(row);
      }
    });
  }

  function sortRows(container) {
    var rows = Array.prototype.slice.call(container.querySelectorAll(':scope > .brands-a-z__letter-row'));
    rows.sort(function (a, b) {
      var la = a.getAttribute('data-letter') || '';
      var lb = b.getAttribute('data-letter') || '';
      if (la === '#') return 1;
      if (lb === '#') return -1;
      return la.localeCompare(lb);
    });
    rows.forEach(function (r) {
      container.appendChild(r);
    });
  }

  function sortLinks(container) {
    container.querySelectorAll('.brands-a-z__links').forEach(function (wrap) {
      var links = Array.prototype.slice.call(wrap.querySelectorAll('a.brands-a-z__link'));
      links.sort(function (a, b) {
        return a.textContent.trim().localeCompare(b.textContent.trim(), undefined, { sensitivity: 'base' });
      });
      links.forEach(function (l) {
        wrap.appendChild(l);
      });
    });
  }

  async function mergeAllPages(root, sectionDomId) {
    if (root.getAttribute('data-brands-az-started') === '1') return;
    root.setAttribute('data-brands-az-started', '1');
    while (true) {
      var nextUrl = root.getAttribute('data-merge-next');
      if (!nextUrl) break;
      var res = await fetch(nextUrl, { credentials: 'same-origin', headers: { Accept: 'text/html' } });
      if (!res.ok) break;
      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fetchedSection = doc.getElementById(sectionDomId);
      if (!fetchedSection) break;
      var fetchedRoot = fetchedSection.querySelector('.brands-a-z__merge-root');
      if (!fetchedRoot) break;
      var newRows = Array.prototype.slice.call(fetchedRoot.querySelectorAll('.brands-a-z__letter-row'));
      mergeRows(root, newRows);
      var next = fetchedRoot.getAttribute('data-merge-next') || '';
      root.setAttribute('data-merge-next', next);
    }
    sortRows(root);
    sortLinks(root);
  }

  function init() {
    document.querySelectorAll('.brands-a-z__merge-root[data-merge-next]').forEach(function (root) {
      var next = root.getAttribute('data-merge-next');
      if (!next) return;
      var sectionEl = root.closest('section[id^="section-"]');
      if (!sectionEl || !sectionEl.id) return;
      mergeAllPages(root, sectionEl.id).catch(function (e) {
        console.warn('Brands A–Z: could not merge extra collection pages', e);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
